import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=6b16fb02&scoped=true"
import script from "./FAQPage.vue?vue&type=script&lang=js"
export * from "./FAQPage.vue?vue&type=script&lang=js"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=6b16fb02&prod&lang=css"
import style1 from "./FAQPage.vue?vue&type=style&index=1&id=6b16fb02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b16fb02",
  null
  
)

export default component.exports